(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/stream-player-solidtango/assets/javascripts/components/stream-player-solidtango-container.js') >= 0) return;  svs.modules.push('/components/racing/stream-player-solidtango/assets/javascripts/components/stream-player-solidtango-container.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useNavigationState
} = svs.racing.navigation;
const {
  useHistory
} = ReactRouterDOM;
const {
  buildLocation
} = svs.racing.navigation.location;
const {
  useEffect,
  useState
} = React;
const {
  StreamPlayerSolidtango
} = svs.components.racing.streamPlayerSolidtango;
const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
const {
  urlMapping
} = svs.core;
const StreamPlayerSolidtangoContainer = () => {
  const navState = useNavigationState();
  const [showLive, setShowLive] = useState(false);
  const [vodFromQuery, setVodFromQuery] = useState('');
  const history = useHistory();

  useEffect(() => {
    if (navState.showLive) {
      if (!isLoggedIn) {
        if (navState.showLiveRedirect) {
          const newLocation = buildLocation(_objectSpread(_objectSpread({}, navState), {}, {
            showLive: false,
            showLiveRedirect: false,
            assetId: ''
          }));
          history.replace(newLocation);
          setVodFromQuery('');
          return null;
        }
        const {
          pathname,
          search
        } = buildLocation(_objectSpread(_objectSpread({}, navState), {}, {
          showLive: true,
          showLiveRedirect: true
        }));
        const returnUrl = "".concat(urlMapping.get('racing')).concat(pathname).concat(search);
        svs.components.customer_login.login({
          returnUrl
        });
        return null;
      }
      const newLocation = buildLocation(_objectSpread(_objectSpread({}, navState), {}, {
        showLive: false,
        showLiveRedirect: false,
        assetId: ''
      }));
      history.replace(newLocation);
      setVodFromQuery(navState === null || navState === void 0 ? void 0 : navState.assetId);
      setShowLive(true);
    }
  }, []);
  return React.createElement(StreamPlayerSolidtango, {
    showLive: showLive,
    vodFromQuery: vodFromQuery
  });
};
setGlobal('svs.components.racing.streamPlayerSolidtango.StreamPlayerSolidtangoContainer', StreamPlayerSolidtangoContainer);

 })(window);